// Promotions chosen on the model selection pages, remembered per browser: { promoId: true|false }.
// A promo never touched follows its admin setting (pre-checked unless "décochée par défaut" or exclusive).
const KEY = "fautras_promo_choice";
const OLD_KEY = "fautras_promo_ids";

const stored = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    if (v && typeof v === "object" && !Array.isArray(v)) return v;
  } catch { /* ignore */ }
  return {};
};

export const isPromoOn = (p) => {
  const s = stored();
  if (p.id in s) return !!s[p.id];
  if (typeof p.precheck === "boolean") return p.precheck;
  return !p.default_off && !p.exclusive;
};

export const setPromoOn = (p, on, promos) => {
  const s = stored();
  if (on && p.exclusive) promos.forEach((x) => { s[x.id] = x.id === p.id; });
  else if (on) promos.forEach((x) => { if (x.exclusive && isPromoOn(x)) s[x.id] = false; });
  s[p.id] = on;
  localStorage.setItem(KEY, JSON.stringify(s));
  localStorage.removeItem(OLD_KEY);
};
